import { render, staticRenderFns } from "./SemaglutideOption.vue?vue&type=template&id=b2da3d9c&scoped=true"
import script from "./SemaglutideOption.vue?vue&type=script&lang=js"
export * from "./SemaglutideOption.vue?vue&type=script&lang=js"
import style0 from "./SemaglutideOption.vue?vue&type=style&index=0&id=b2da3d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2da3d9c",
  null
  
)

export default component.exports